// @flow
import { createContext } from 'react';

export const CookieContext = createContext({});
